import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";

/**
 * Primary UI component for user interaction
 */
export var Separator = function Separator(_ref) {
  var classNames = _ref.classNames;
  return /*#__PURE__*/_jsx("div", {
    className: "border border-t-0 border-l-0 border-r-0 border-b border-gray-300 ".concat(classNames)
  });
};
Separator.defaultProps = {
  classNames: 'my-8'
};